import React, { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import cn from 'classnames';
import { GradientText } from '../gradient-text';
import ThinkStarIcon from '@/assets/icons/think-star.svg?react';
import ThinkStartFinishedIcon from '@/assets/icons/think-start-finished.svg?react';

interface ThinkingHeaderProps {
  isFinishThinking: boolean;
  className?: string;
}

/**
 * 思考块头部组件
 * 根据思考状态展示不同的图标和文案
 */
export const ThinkingHeader: React.FC<ThinkingHeaderProps> = props => {
  const { isFinishThinking, className } = props;
  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      {isFinishThinking ? <ThinkStartFinishedIcon /> : <ThinkStarIcon />}
      <div className="text-sm">
        {/* 文案：已完成思考，展示完成思考的文案；未完成思考，展示思考中的文案 */}
        {isFinishThinking ? (
          <span className="text-[#262626] text-[16px]">View thought process</span>
        ) : (
          <GradientText className="text-[16px]" text="Processing your request..." />
        )}
      </div>
    </div>
  );
};

interface ThinkingBlockProps {
  isFinishThinking: boolean;
  children: React.ReactNode;
}

export const ThinkingBlock: React.FC<ThinkingBlockProps> = props => {
  const { children, isFinishThinking } = props;
  const [isCollapsed, setIsCollapsed] = useState(isFinishThinking);

  useEffect(() => {
    if (isFinishThinking) {
      setIsCollapsed(true);
    }
  }, [isFinishThinking]);

  return (
    <div className="mb-4">
      <div
        className="flex items-center gap-2 cursor-pointer select-none mb-4"
        onClick={() => {
          setIsCollapsed(!isCollapsed);
        }}
      >
        <ThinkingHeader isFinishThinking={isFinishThinking} />
        <ChevronDown size={16} className={isCollapsed ? 'rotate-0' : 'rotate-180'} />
      </div>
      <div className={cn('border-l-[2px] border-[#E5E5E5] pl-[8px] py-2', { hidden: isCollapsed })}>{children}</div>
    </div>
  );
};
